export default "__VITE_ASSET__GLKOATgW__"